import styled from 'styled-components';
import { getAlertColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
export const Container = styled(Box)`
  width: 100%;
  background: ${props => getAlertColor(`${props.intent}.base`)(props)};
`;
export const Message = styled(Text)`
  display: flex;
  align-items: center;
  padding: 10px;
  gap: ${props => themeGet('space.2')(props)}px;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getAlertColor(`${props.intent}.text`)(props)};
`;